import React, { Component } from "react";
import styled from "styled-components";

const RestrictedContainerElement = styled.section`
	box-sizing: border-box;
	margin: 0 auto;
	max-width: 900px;
	width: 100%;
`;

type Props = {
	style: any,
	children: any,
};
type State = {};
class RestrictedContainer extends Component<Props, State> {
	render(props) {
		return (
			<RestrictedContainerElement
				className={this.props.className}
				style={{ ...this.props.style }}
			>
				{this.props.children}
			</RestrictedContainerElement>
		);
	}
}

export default RestrictedContainer;



// WEBPACK FOOTER //
// ../shared/components/RestrictedContainer.js